$(function () {
    const pageContent = document.querySelector('main');
    if (!pageContent) return;
    pageContent.setAttribute('data-content-animations', '');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) return;
    const motionElements = [];
    let observer;

    function showImmediately(element) {
        element.classList.add('home-motion-instant', 'is-visible');
        if (observer) observer.unobserve(element);
    }

    function animateHero(element, delay, heading) {
        if (!element || motionElements.some(parent => parent.contains(element))) return;
        element.style.setProperty('--home-delay', delay + 'ms');
        element.classList.add(heading ? 'home-hero-heading-enter' : 'home-hero-text-enter');
        motionElements.push(element);
    }

    pageContent.querySelectorAll('.home-hero').forEach(hero => {
        const photo = hero.querySelector('.img');
        if (photo && !photo.closest('.hero-photo-slider') && !photo.classList.contains('hero-video')) {
            motionElements.push(photo);
            function animatePhoto() {
                if (!reducedMotion.matches) photo.classList.add('home-hero-photo-enter');
            }
            if (photo.classList.contains('lozad') && photo.getAttribute('data-loaded') !== 'true') {
                $(photo).one('lozadLoaded', animatePhoto);
            } else {
                animatePhoto();
            }
        }
        const content = hero.querySelector('.home-hero-content');
        if (!content) return;
        animateHero(content.querySelector('.eyebrow'), 0, false);
        animateHero(content.querySelector('h1'), 100, true);
        content.querySelectorAll('p:not(.eyebrow)').forEach(element => animateHero(element, 200, false));
        const actions = content.querySelector('.hero-actions');
        if (actions) {
            animateHero(actions, 300, false);
        } else {
            content.querySelectorAll('.btn, .text-link').forEach(element => animateHero(element, 300, false));
        }
    });

    if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            });
        }, { threshold: 0.05 });

        const selector = '.blog-card, .experience-photo, .form-wrapper, .tour-heading-section, .tour-gallery, .tour-card, .process-step, .activity-item, h1, h2, h3, h4, h5, h6, p, .eyebrow, .highlight-text, .experience-number, .tour-card-highlight, .tour-card-summary, .object-facts, .btn, .text-link, .wp-block-list';
        const candidates = Array.from(pageContent.querySelectorAll(selector)).filter(element =>
            !element.closest('.home-hero, .ribbon, .main-header, footer')
        );
        const groups = new Map();

        candidates.forEach(element => {
            if (candidates.some(parent => parent !== element && parent.contains(element))) return;
            const card = element.closest('.tour-card, .blog-card, .process-step, .activity-item');
            const group = element.closest('.row, .activity-list, .wp-block-columns') || element.parentElement;
            if (!groups.has(group)) groups.set(group, []);
            const cards = groups.get(group);
            if (card && cards.indexOf(card) === -1) cards.push(card);
            const sequential = element.matches('.process-step, .activity-item');
            const formText = element.matches('.form-wrapper') || element.closest('.form-contact');
            const tourGallery = element.matches('.tour-gallery');
            const tourHeading = element.matches('.tour-heading-section, .tour-heading');
            const delay = tourHeading ? 100 : formText || tourGallery ? 200 :
                card ? Math.min(cards.indexOf(card) * (sequential ? 120 : 65), sequential ? 360 : 195) : 0;
            const bounds = element.getBoundingClientRect();
            // Content already on screen is never hidden for a scroll reveal.
            if (!formText && !tourGallery && !tourHeading && bounds.bottom > 0 && bounds.top < window.innerHeight) return;
            if (element.contains(document.activeElement)) return;

            element.style.setProperty('--home-delay', delay + 'ms');
            element.classList.add('home-reveal');
            motionElements.push(element);
            observer.observe(element);
        });
    }

    pageContent.addEventListener('focusin', event => {
        motionElements.forEach(element => {
            if (element === event.target || element.contains(event.target)) showImmediately(element);
        });
    });

    function onMotionPreferenceChange(event) {
        if (!event.matches) return;
        motionElements.forEach(showImmediately);
        if (observer) observer.disconnect();
    }
    if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', onMotionPreferenceChange);
    } else {
        reducedMotion.addListener(onMotionPreferenceChange);
    }
});
